import { useDispatch, useSelector } from 'react-redux'

import {
  fetchUserAction,
  updateUserAction,
} from '../../store/reducers/userReducer'
import { AppDispatch, RootState } from '../../store/store'

export const useUser = () => {
  const user = useSelector((state: RootState) => state.userReducer.user)
  const dispatch: AppDispatch = useDispatch()
  const isLoading = useSelector(
    (state: RootState) => state.userReducer.isLoading,
  )
  const isUpdating = useSelector(
    (state: RootState) => state.userReducer.isUpdating,
  )

  return {
    user,
    isLoading,
    isUpdating,
    fetchUser: () => dispatch(fetchUserAction()),
    updateUser: (
      userSub: string,
      data: {
        firstName: string
        lastName: string
      },
    ) =>
      dispatch(
        updateUserAction({
          userSub,
          data,
        }),
      ),
  }
}
